import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

import {SharedStatusPageFormDefaultValues} from "@/pages/statuspages/shared/StatusPageForm.utils.ts";
import {
  CreateStatusPageChecksFormValues,
  CreateStatusPageFormData,
} from "@/pages/statuspages/statuspages-create/CreateStatusPageForm.types.ts";
import {StatusPageDesignTabSchema} from "@/pages/statuspages/tabs/design/StatusPageDesignTab.form.ts";
import {StatusPageGeneralSchema} from "@/pages/statuspages/tabs/general/StatusPageGeneralTab.form.ts";

export const CreateStatusPageChecksSchema = Yup.object({
  initial_services: Yup.array()
    .of(
      Yup.object({
        id: Yup.number().required(),
      })
    )
    .optional(),
});

export const CreateStatusPageChecksDefaultValues: CreateStatusPageChecksFormValues = {
  initial_services: [],
};

export const mergeSchemas = <T extends Yup.AnyObject>(
  ...schemas: Yup.ObjectSchema<Yup.AnyObject>[]
): Yup.ObjectSchema<T> => {
  const [first, ...rest] = schemas;

  return rest.reduce((mergedSchemas, schema) => mergedSchemas.concat(schema), first) as Yup.ObjectSchema<T>;
};

export const NewStatusPageYupResolver = yupResolver(
  mergeSchemas<CreateStatusPageFormData>(
    StatusPageGeneralSchema,
    StatusPageDesignTabSchema,
    CreateStatusPageChecksSchema
  )
);

export const CreateStatusPageFormDefaultValues: CreateStatusPageFormData = {
  ...SharedStatusPageFormDefaultValues,
  ...CreateStatusPageChecksDefaultValues,
};
